import React from 'react'
import {
  dig,
  dateString,
  formattedDuration,
  formatStat,
  niceBlockedMessage,
} from '../shared'
import Cell from './Cell'

const PostCell = ({post, onShare, onDelete}) => {
  const actions = []
  if (onDelete) { actions.unshift({ title: 'Delete', onClick: () => { onDelete(post) } }) }
  if (!post.is_blocked) {
    if (onShare) { actions.unshift({ title: 'Copy Link', onClick: () => { onShare(post) } }) }
  }

  return <Cell>
    <Cell.Image src={post.signed_image_urls['100']} alt='' />
    <Cell.Body>
      <Cell.Line>
        <Cell.LineTitle>{post.title}</Cell.LineTitle>
        {post.is_blocked && <Cell.LineImportant>{niceBlockedMessage(post.is_blocked)}</Cell.LineImportant>}
        {!post.is_blocked && post.is_featured && <Cell.LineFeatured />}
      </Cell.Line>

      <Cell.Line>
        <div>{formattedDuration(post.duration_seconds)}</div>
        <div>{dateString(post.created_at)}</div>
      </Cell.Line>

      <Cell.Line>
        {<Cell.PlayCount>{formatStat(post.play_count)}</Cell.PlayCount>}
        {<Cell.ShareCount>{formatStat(post.share_count)}</Cell.ShareCount>}
        {<Cell.LikeCount>{formatStat(post.like_count)}</Cell.LikeCount>}
        {<Cell.CommentCount>{formatStat(post.comment_count)}</Cell.CommentCount>}
      </Cell.Line>

      {(post.genre || post.effect) && <Cell.Line>
        {post.genre && <Cell.MusicNote>{post.genre}</Cell.MusicNote>}
        {post.effect && <Cell.AudioEffect>{post.effect}</Cell.AudioEffect>}
      </Cell.Line>}

      <Cell.Line>
        {dig(post, 'beat', 'beat_name') &&
          <Cell.MusicNote>{dig(post, 'beat', 'beat_name')}</Cell.MusicNote>
        }
      </Cell.Line>
    </Cell.Body>
    {actions.length > 0 && <Cell.OverflowButton actions={actions} />}
  </Cell>
}

export default PostCell
